import React, { useEffect, useState } from "react";
import LookupUmat from "../LookupUmat";
import { getAvatarPlaceholder, apiFetch, getGlobalVariables } from "../../utils/wkCommon";
import { isZh } from "../../utils/language";
import CardUmat from "../CardUmat";

export default function PreRegParticipantSection({

  formMode,

  allowRoleSelection,

  allowRegistrarSelection,

  step,
  setStep,

  registrarType,
  setRegistrarType,

  registrationRole,
  setRegistrationRole,

  selectedUmat,
  setSelectedUmat,

  fillFromUmat,

  baseData,
  setBaseData,
  formConfig,
}) {

  const formScope =
    formConfig?.preRegCustomFields?.formScope ||
    "internal_external";

  const allowExternal =
    formScope === "internal_external";

  const allowPublic =
    formScope === "internal_public";

  const [educationOptions, setEducationOptions] =
    useState([]);

  const [occupationOptions, setOccupationOptions] =
    useState([]);

  const [fotangOptions, setFotangOptions] =
    useState([]);

  useEffect(() => {

    loadGlobalVars();

  }, []);

  async function loadGlobalVars() {

    try {

      const vars =
        await getGlobalVariables([
          "EDUCATION_TEMPLATES",
          "OCCUPATION_TEMPLATES",
          "FTEXT_TEMPLATES",
        ]);

      setEducationOptions(
        vars?.EDUCATION_TEMPLATES || []
      );

      setOccupationOptions(
        vars?.OCCUPATION_TEMPLATES || []
      );

      setFotangOptions(
        vars?.FTEXT_TEMPLATES || []
      );

    } catch (err) {

      console.error(
        "loadGlobalVars",
        err
      );
    }
  }

  if (step !== 1) return null;

  function getAgeFromBirthdate(birthdate) {
    if (!birthdate) { return "-"; }
    const dob = new Date(birthdate);

    if (
      Number.isNaN(dob.getTime())
    ) {
      return "-";
    }

    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();

    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 
        || (monthDiff === 0 && today.getDate() < dob.getDate())) 
    { 
      age -= 1; 
    }

    return age >= 0
      ? `${age}`
      : "-";
  }

  return (
    <>

      {allowRegistrarSelection && (
        <div className="section-card">

          <div className="section-title">
            Registrar Type
          </div>

          <div className="radio-row">

            <RadioButton
              checked={registrarType === "internal"}
              label="Internal"
              onClick={() =>
                setRegistrarType("internal")
              }
            />

            {allowExternal && (
            <RadioButton
              checked={registrarType === "external"}
              label="External"
              onClick={() =>
                setRegistrarType("external")
              }
            />
            )}

            {allowPublic && (
            <RadioButton
              checked={registrarType === "public"}
              label="Publik"
              onClick={() =>
                setRegistrarType("public")
              }
            />
            )}
          </div>

        </div>
      )}

      {registrarType === "internal" && (
        <>

          {allowRegistrarSelection && (
            <div className="section-card">

              <div className="section-title">
                Lookup Umat
              </div>

              <LookupUmat
                value={selectedUmat}

                onChange={async (u) => {

                  if (!u?.documentId) {

                    setSelectedUmat(null);
                    return;
                  }

                  try {

                    const API_URL =
                      process.env.REACT_APP_BACKEND_URL;

                    const detailUrl =
                      `${API_URL}/api/umats/${u.documentId}` +
                      `?populate%5B0%5D=avatarpic` +
                      `&populate%5B1%5D=profilepic` +
                      `&populate%5B2%5D=fotang` +
                      `&populate%5B3%5D=area`;

                    const resp =
                      await apiFetch(detailUrl);

                    const fullUmat =
                      resp?.data || u;

                    setSelectedUmat(fullUmat);

                    fillFromUmat(fullUmat);

                  } catch (err) {

                    console.error(err);

                    setSelectedUmat(u);

                    fillFromUmat(u);
                  }
                }}
              />

            </div>
          )}

          {selectedUmat && (
            <div className="umat-card">
              <CardUmat
                avatar={
                  selectedUmat?.avatarpic?.url
                }
                line1={
                  [
                    selectedUmat?.umatID,
                    selectedUmat?.chineseName,
                  ]
                    .filter(Boolean)
                    .join(" • ")
                }
                line2={
                  selectedUmat?.fullName ||
                  selectedUmat?.displayName
                }
                line3={
                  selectedUmat?.area?.name ||
                  selectedUmat?.district ||
                  selectedUmat?.alamat
                }

              />
              <div className="umat-grid">

                <div>
                  <div className="small-label">
                    Gender
                  </div>

                  <div>
                    {selectedUmat.gender || "-"}
                  </div>
                </div>

                <div>
                  <div className="small-label">
                    {isZh()
                      ? "年齡"
                      : "Usia"}
                  </div>

                  <div>
                    {getAgeFromBirthdate(
                      selectedUmat.birthdate
                    )}
                  </div>
                </div>

                <div>
                  <div className="small-label">
                    {isZh()
                      ? "電話"
                      : "No. Telp"}
                  </div>

                  <div>
                    {selectedUmat.mobilePhone || "-"}
                  </div>
                </div>

              </div>
            </div>
          )}

        </>
      )}

      {registrarType === "external" && (

        <div className="section-card">

          <InputField
            label={
              isZh()
                ? "姓名"
                : "Nama Lengkap"
            }
            value={baseData.name}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                name: v,
              }))
            }
          />

          <div className="field-wrap">

            <label className="field-label">
              Gender
            </label>

            <select
              className="field-input"
              value={baseData.gender || ""}
              onChange={(e) =>
                setBaseData((p) => ({
                  ...p,
                  gender: e.target.value,
                }))
              }
            >
              <option value="">
                --
              </option>

              <option value="乾 Pria">
                乾 Pria
              </option>

              <option value="坤 Wanita">
                坤 Wanita
              </option>

            </select>

          </div>

          <InputField
            label={
              isZh()
                ? "年齡"
                : "Usia"
            }
            type="number"
            value={baseData.age}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                age: v,
              }))
            }
          />

          <div className="field-wrap">

            <label className="field-label">
              {isZh()
                ? "職業"
                : "Pekerjaan"}
            </label>

            <select
              className="field-input"
              value={baseData.occupation || ""}
              onChange={(e) =>
                setBaseData((p) => ({
                  ...p,
                  occupation: e.target.value,
                }))
              }
            >

              <option value="">
                --
              </option>

              {occupationOptions.map((o) => {

                const text =
                  `${o.zh} ${o.id}`;

                return (
                  <option
                    key={text}
                    value={text}
                  >
                    {text}
                  </option>
                );
              })}

            </select>

          </div>

          <div className="field-wrap">

            <label className="field-label">
              {isZh()
                ? "學歷"
                : "Pendidikan"}
            </label>

            <select
              className="field-input"
              value={baseData.education || ""}
              onChange={(e) =>
                setBaseData((p) => ({
                  ...p,
                  education: e.target.value,
                }))
              }
            >

              <option value="">
                --
              </option>

              {educationOptions.map((o) => {

                const text =
                  `${o.zh} ${o.id}`;

                return (
                  <option
                    key={text}
                    value={text}
                  >
                    {text}
                  </option>
                );
              })}

            </select>

          </div>

          <div className="field-wrap">

            <label className="field-label">
              佛堂
            </label>

            <select
              className="field-input"
              value={
                baseData.fotang || ""
              }
              onChange={(e) =>
                setBaseData((p) => ({
                  ...p,
                  fotang:
                    Number(e.target.value),
                }))
              }
            >

              <option value="">
                --
              </option>

              {fotangOptions.map((o) => {

                const text =
                  `${o.zh} ${o.id}`;

                return (
                  <option
                    key={o.idno}
                    value={o.idno}
                  >
                    {text}
                  </option>
                );
              })}

            </select>

          </div>

          <InputField
            label={
              isZh()
                ? "地址"
                : "Alamat"
            }
            value={baseData.address}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                address: v,
              }))
            }
          />

          <InputField
            label={
              isZh()
                ? "電話"
                : "No. Telp / WhatsApp"
            }
            value={baseData.phoneNumber}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                phoneNumber: v,
              }))
            }
          />

          <InputField
            label={
              isZh()
                ? "備註"
                : "Catatan"
            }
            textarea
            value={baseData.notes}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                notes: v,
              }))
            }
          />

        </div>
      )}

      {registrarType === "public" && (
        <div className="section-card">
          <InputField
            label="姓名 Nama"
            value={baseData.nonUmatName}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                nonUmatName: v,
              }))
            }
          />

          <div className="field-wrap">
            <label className="field-label">
              性別 Gender
            </label>
            <select
              className="field-input"
              value={
                baseData.nonUmatGender || ""
              }
              onChange={(e) =>
                setBaseData((p) => ({
                  ...p,
                  nonUmatGender:
                    e.target.value,
                }))
              }
            >
              <option value="">
                --
              </option>
              <option value="乾 Pria">
                乾 Pria
              </option>
              <option value="坤 Wanita">
                坤 Wanita
              </option>
            </select>
          </div>

          <InputField
            label="年齡 Usia"
            type="number"
            value={baseData.nonUmatAge}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                nonUmatAge: v,
              }))
            }
          />

          <InputField
            label="電話 No. Telp"
            value={baseData.nonUmatPhoneNo}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                nonUmatPhoneNo: v,
              }))
            }
          />

          <InputField
            label="地址 Alamat"
            value={baseData.nonUmatAddress}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                nonUmatAddress: v,
              }))
            }
          />

          <InputField
            label="備註 Catatan"
            textarea
            value={baseData.nonUmatRemarks}
            onChange={(v) =>
              setBaseData((p) => ({
                ...p,
                nonUmatRemarks: v,
              }))
            }
          />

        </div>
      )}

      <div className="section-card">

        <div className="section-title">
          {isZh()
            ? "報名身份"
            : "Daftar Sebagai"}
        </div>

        {allowRoleSelection ? (

          <div className="radio-row">

            <RadioButton
              checked={registrationRole === "peserta"}
              label={
                isZh()
                  ? "參加者"
                  : "Peserta"
              }

              onClick={() =>
                setRegistrationRole("peserta")
              }
            />

            <RadioButton
              checked={registrationRole === "petugas"}
              label={
                isZh()
                  ? "工作人員"
                  : "Petugas"
              }

              onClick={() =>
                setRegistrationRole("petugas")
              }
            />

          </div>

        ) : (

          <div className="locked-role-box">

            {registrationRole === "petugas"
              ? (
                isZh()
                  ? "工作人員"
                  : "PETUGAS"
              )
              : (
                isZh()
                  ? "參加者"
                  : "PESERTA"
              )}

          </div>

        )}

      </div>

      <div className="bottom-actions">

        <button
          type="button"
          className="btn-primary"
          onClick={() => {
            if (
              registrarType === "internal" &&
              !selectedUmat
            ) {
              alert(
                isZh()
                  ? "請先選擇會員"
                  : "Harap pilih umat terlebih dahulu"
              );
              return;
            }
            setStep(2);
          }}
        >
          {isZh()
            ? "下一步"
            : "Lanjut"}
        </button>

      </div>

      <style>{`

        .section-card{
          background:#fff;
          border:1px solid #dbe3ef;
          border-radius:1rem;
          padding:1rem;
          margin-bottom:1rem;
        }

        .section-title{
          font-size:0.95rem;
          font-weight:700;
          margin-bottom:1rem;
        }

        .radio-row{
          display:flex;
          gap:1rem;
          flex-wrap:wrap;
        }

        .radio-item{
          display:flex;
          align-items:center;
          gap:0.5rem;
          font-size:0.9rem;
        }

        .locked-role-box{
          padding:0.8rem 1rem;
          border-radius:0.8rem;
          background:#eff6ff;
          border:1px solid #bfdbfe;
          font-size:0.9rem;
          font-weight:700;
          color:#1d4ed8;
        }

        .umat-card{
          border:1px solid #dbe3ef;
          border-radius:1rem;
          padding:1rem;
          margin-bottom:1rem;
          background:#fff;
        }

        .umat-avatar img{
          width:4.5rem;
          height:4.5rem;
          border-radius:999rem;
          object-fit:cover;
        }

        .umat-body{
          flex:1;
        }

        .umat-name{
          font-size:1rem;
          font-weight:700;
        }

        .umat-line{
          font-size:0.85rem;
          margin-top:0.3rem;
          color:#475569;
        }

        .umat-grid{
          display:grid;
          grid-template-columns:repeat(3,minmax(0,1fr));
          gap:1rem;
          margin-top:1rem;
          padding-top:1rem;
          border-top:1px solid #e2e8f0;
        }

        .small-label{
          font-size:0.72rem;
          color:#64748b;
        }

        .bottom-actions{
          display:flex;
          justify-content:flex-end;
        }

        .btn-primary{
          border:none;
          background:#2563eb;
          color:#fff;
          border-radius:0.7rem;
          padding:0.75rem 1.2rem;
          font-size:0.9rem;
          font-weight:600;
          cursor:pointer;
        }

      `}</style>

    </>
  );
}

function RadioButton({
  checked,
  label,
  onClick,
}) {

  return (
    <label className="radio-item">

      <input
        type="radio"
        checked={checked}
        onChange={onClick}
      />

      <span>{label}</span>

    </label>
  );
}

function InputField({
  label,
  value,
  onChange,
  textarea,
  type = "text",
}) {

  return (
    <div className="field-wrap">

      <label className="field-label">
        {label}
      </label>

      {textarea ? (

        <textarea
          className="field-input textarea"
          value={value || ""}
          onChange={(e) =>
            onChange(e.target.value)
          }
        />

      ) : (

        <input
          className="field-input"
          type={type}
          value={value || ""}
          onChange={(e) =>
            onChange(e.target.value)
          }
        />

      )}

      <style>{`

        .field-wrap{
          margin-bottom:1rem;
        }

        .field-label{
          display:block;
          margin-bottom:0.4rem;
          font-size:0.85rem;
          font-weight:600;
        }

        .field-input{
          width:100%;
          border:1px solid #dbe3ef;
          border-radius:0.7rem;
          padding:0.75rem 0.9rem;
          font-size:0.9rem;
        }

        .textarea{
          min-height:6rem;
          resize:vertical;
        }

      `}</style>

    </div>
  );
}